import {
  LOGIN_REQUEST,
  LOGOUT_REQUEST,
  LOGIN_REQUEST_SUCCESS,
  LOGOUT_REQUEST_SUCCESS,
  LOGIN_REQUEST_FAIL,
  FORGOT_PASSWORD,
  PASSWORD_RESET,
  CLEAR_ERROR,
} from 'store/constants/action-types';

export const userLoginAction = (payload) => {
  return { type: LOGIN_REQUEST, payload: payload };
};

export const userLogoutAction = () => {
  return { type: LOGOUT_REQUEST };
};

export const userLoginSuccessAction = () => {
  return { type: LOGIN_REQUEST_SUCCESS };
};

export const userLoginFailAction = () => {
  return { type: LOGIN_REQUEST_FAIL };
};

export const userLogoutSuccessAction = () => {
  return { type: LOGOUT_REQUEST_SUCCESS };
};

export const userForgotPasswordAction = (payload) => {
  return { type: FORGOT_PASSWORD, payload: payload };
};

export const userResetPasswordAction = (payload) => {
  return { type: PASSWORD_RESET, payload: payload };
};

export const clearErrorAction = () => {
  return { type: CLEAR_ERROR };
};
